import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#headphones_svg__a)\"><path d=\"M4.336 10.586h1.953s.781 0 .781.781v6.64s0 .782-.78.782H4.335s-.781 0-.781-.781v-6.64s0-.782.78-.782m9.376 0h1.954s.781 0 .781.781v6.64s0 .782-.78.782H13.71s-.781 0-.781-.781v-6.64s0-.782.78-.782\"></path><path d=\"M1.21 14.688V10a8.79 8.79 0 0 1 17.58 0v4.688\"></path></g><defs><clipPath id=\"headphones_svg__a\"><path fill=\"#fff\" d=\"M0 0h20v20H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }